import React from "react";
import { Text, Tooltip } from "@chakra-ui/react";

// Tooltip that also works on mobile tap (no tabIndex side effects on desktop).
// Uses pointer events to distinguish mouse hover from touch, and onTouchEnd for tap toggle.
export function TapTooltip({ children, ...tooltipProps }) {
  const [isOpen, setIsOpen] = React.useState(false);
  const triggerRef = React.useRef(null);

  React.useEffect(() => {
    if (!isOpen) return;
    const close = (e) => {
      if (triggerRef.current && triggerRef.current.contains(e.target)) return;
      setIsOpen(false);
    };
    document.addEventListener("touchstart", close);
    return () => document.removeEventListener("touchstart", close);
  }, [isOpen]);

  return (
    <Tooltip isOpen={isOpen} {...tooltipProps}>
      <Text
        ref={triggerRef}
        as="span"
        textDecoration="underline dotted"
        cursor="help"
        onPointerEnter={(e) => {
          if (e.pointerType === "mouse") setIsOpen(true);
        }}
        onPointerLeave={(e) => {
          if (e.pointerType === "mouse") setIsOpen(false);
        }}
        onTouchEnd={() => setIsOpen((o) => !o)}
      >
        {children}
      </Text>
    </Tooltip>
  );
}
